import React, {useEffect, useState} from 'react';
import fire from '../../config/Fire';
import {NavBar} from '../nav-bar/NavBar';
import {CSVLink} from "react-csv";

//TODO The queries can be made more efficient.
//     Am I limited by Cloud Firestore?
export const ExportData = (props) => {
    const [orgIds, setOrgIds] = useState(null);
    const [orgName, setOrgName] = useState(null);
    const [hasError, setHasError] = useState(false);
    const [treeExportData, setTreeExportData] = useState([["condition", "size", "created_timestamp", "latitude", "longitude"]]);
    console.log({treeExportData});
    const db = fire.firestore(fire)

    useEffect(() => {
        if (orgIds === null) getOrgs()
    });

    const getOrgs = () => {
        let orgIds = [];
        const adminOrganizations = db.collection("admin_to_organizations")
        const query = adminOrganizations.where("user_id", "==", props.userId);
        query.get().then(function (snapshot) {
            const docs = snapshot.docs;
            orgIds = docs.map((element) => element.data()['organization']);
            setOrgIds(orgIds)
            if (orgIds.length > 0) {
                getOrgInfo(orgIds[0])
                getUsersInOrg(orgIds[0])
            }
        }, function (error) {
            console.error(error)
        });
    }

    const getOrgInfo = (orgId) => {
        const query = db.collection("organizations").doc(orgId);
        query.get().then(function (snapshot) {
            const orgData = snapshot.data();
            setOrgName(orgData['name'])
        }, function (error) {
            console.error(error)
        });
    }

    const getUsersInOrg = (orgId) => {
        const query = db.collection("user_to_organizations").where("organization_id", "==", orgId);
        query.get().then(function (snapshot) {
            const docs = snapshot.docs;
            const users = docs.map((element) => element.data()['user_id']);
            getTreeInformationForUsers(users)
        }, function (error) {
            console.error(error)
        });
    }

    const getTreeInformationForUsers = (users) => {
        const query = db.collection("trees");
        setHasError(false);

        // We can only query for 10 users at a time
        const userGroups = new Array(Math.ceil(users.length / 10))
            .fill()
            .map(_ => users.splice(0, 10))

        const queries = userGroups.map(group => query.where("created_by", "in", group).get())
        Promise.all(queries).then((values) => {
            const snapshots = values.reduce((a, b) => a.concat(b), []);
            console.log({snapshots});
            return snapshots.map(snapshot => {
                const trees = snapshot.docs.map((element) => element.data());
                return trees.map(tree => {
                    const location = tree["location"];
                    return [tree["condition"],
                        tree["size"],
                        tree["created_timestamp"].seconds,
                        location["_lat"],
                        location["_long"]];
                });
            })
        }, function (error) {
            setHasError(true);
            console.error(error)
        }).then((queryTrees) => {
            const trees = queryTrees.reduce((a, b) => a.concat(b), []);
            setTreeExportData((oldTreeExportData) => [...oldTreeExportData, ...trees]);
        });
    }

    return (
        <div>
            <NavBar {...props} />
            {(hasError) &&
            (<div className="col-md-5 margin-top-container">
                <p>Error, try again later</p>
            </div>)
            } {(orgIds === null && !hasError) &&
        (<div className="col-md-5 margin-top-container">
            <p>Loading...</p>
        </div>)
        }
            {(orgIds !== null && orgIds.length > 0) &&
            (<div className="col-md-5 margin-top-container">
                <h2>{orgName}</h2>
                <CSVLink
                    filename={orgName + " Export.csv"}
                    target="_blank"
                    data={treeExportData}>
                    <button type="button" className="btn btn-primary"> Download CSV</button>
                </CSVLink>
            </div>)
            }
            {(orgIds !== null && orgIds.length === 0) &&
            (<div className="col-md-5 margin-top-container">
                <h2>You are not an admin for any organizations.</h2>
            </div>)
            }

            <footer className="py-5 bg-black bottom-footer ">
                <div className="container">
                    <p className="m-0 text-center text-white small">Copyright &copy; Tree Tracker
                        App {new Date().getFullYear()} </p>
                </div>
            </footer>

        </div>
    )
}




// WEBPACK FOOTER //
// ./src/components/export-data/ExportData.js